import React, { useState } from "react";
import { HeartHandshake, ChevronDown } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { SectionLayout, SectionIntro } from "@/components/SectionLayout";
import { DUA_CATEGORIES } from "@/data/duas";

const DuaCard = ({ dua }) => {
  const { L, t } = useLang();
  return (
    <div className="maqam-card overflow-hidden rounded-3xl p-5" data-testid={`dua-${dua.id}`}>
      {dua.when && (
        <p className="mb-2 inline-block rounded-full bg-[#EAF2FC] px-3 py-1 text-[11px] font-semibold text-[#3E6B9A]">
          {t("dua.when")}: {L(dua.when)}
        </p>
      )}
      {dua.arabic ? (
        <p dir="rtl" lang="ar" className="font-arabic text-2xl leading-[2] text-[#0A192F]">{dua.arabic}</p>
      ) : null}
      {dua.translit ? (
        <p className="mt-3 text-sm font-semibold italic text-[#3E6B9A]">{dua.translit}</p>
      ) : null}
      <p className="mt-2 text-sm leading-relaxed text-slate-600">{L(dua.translation)}</p>
      {dua.source ? (
        <p className="mt-3 text-[11px] font-medium text-slate-400">{t("dua.source")}: {dua.source}</p>
      ) : null}
    </div>
  );
};

export const DuaLibrary = () => {
  const { L, t } = useLang();
  const [open, setOpen] = useState(DUA_CATEGORIES[0].id);

  return (
    <SectionLayout id="dua" icon={HeartHandshake}>
      <SectionIntro>{t("dua.intro")}</SectionIntro>

      <div className="space-y-3">
        {DUA_CATEGORIES.map((cat) => {
          const isOpen = open === cat.id;
          return (
            <div key={cat.id} data-testid={`dua-category-${cat.id}`}>
              <button
                onClick={() => setOpen(isOpen ? null : cat.id)}
                data-testid={`dua-category-toggle-${cat.id}`}
                aria-expanded={isOpen}
                className="flex w-full items-center justify-between gap-3 rounded-2xl bg-[#0A192F] px-5 py-4 text-left transition-transform active:scale-[0.99]"
              >
                <span className="font-display text-base font-bold text-white">{L(cat.title)}</span>
                <span className="flex items-center gap-2">
                  <span className="rounded-full bg-white/10 px-2 py-0.5 text-[11px] font-bold text-[#E9CE7D]">{cat.duas.length}</span>
                  <ChevronDown size={18} className={`text-[#E9CE7D] transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
                </span>
              </button>
              {isOpen && (
                <div className="mt-3 space-y-3">
                  {cat.duas.map((d) => <DuaCard key={d.id} dua={d} />)}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </SectionLayout>
  );
};
